import type { IconData } from '@stacksjs/iconify-core'

export const highSpeedTrainSide: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M3 45V24.512c0-2.645.023-5.011.06-7.112C3.202 9.345 8.943 3 17 3c4.438 0 8.173 1.925 10.657 5\"/><path d=\"M8 40h16.86c5.906 0 10.455-.134 13.848-.304c4.54-.227 7.566-4.44 5.839-8.644c-2.575-6.264-6.312-11.556-9.967-15.108c-2.183-2.123-5.17-3.078-8.21-3.257A411 411 0 0 0 10 12.073\"/><path d=\"M16.956 20.53a1 1 0 0 1 .848-1.53h8.282c.93 0 1.862.195 2.632.716c2.119 1.431 3.85 3.574 4.955 5.165c.646.93-.041 2.118-1.175 2.118c-3.242-.001-7.721.001-10.392.001c-.69 0-1.328-.355-1.693-.94zM8 27h5.196a1 1 0 0 0 .848-1.53l-3.456-5.53A2 2 0 0 0 8.892 19H8M3 45h42m-9-11H8\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default highSpeedTrainSide
